@if (visible) {
  <div class="mobile-modal" role="dialog" aria-modal="true">
    <div class="modal-content">
      <div class="body">
        <img [src]="wave" class="wave" alt="Wave" loading="lazy" />
        <img [src]="v2Logo" class="phone" alt="Phone" loading="lazy" />

        <button (click)="closeIconAction()">
          <img [src]="closeIcon" class="close" alt="Close" loading="lazy" />
        </button>
      </div>

      <div class="footer">
        <h2>{{ stepsToShow[step()].title }}</h2>

        @if (stepsToShow[step()].isDisclaimer) {
          @if (isFinnet) {
            <div class="disclaimer">
              <ul>
                <li>
                  <span class="emoji" aria-hidden="true">🏢</span>
                  <span
                    >Die Analysen werden von der finanzen.net GmbH erstellt und betrieben und hier
                    unverändert übernommen.</span
                  >
                </li>
                <li>
                  <span class="emoji" aria-hidden="true">🤖</span>
                  <span
                    >AI-generierte Textpassagen sind gekennzeichnet und können trotz sorgfältiger
                    Erstellung Fehler enthalten.</span
                  >
                </li>
                <li>
                  <span class="emoji" aria-hidden="true">🚫</span>
                  <span
                    >Die Analysen ersetzen keine Anlageberatung und dienen ausschließlich zu
                    Informationszwecken.</span
                  >
                </li>
              </ul>

              <p class="terms">
                Mit dem Fortfahren stimmst Du unseren
                <a routerLink="/privacy" queryParamsHandling="preserve">Datenschutzbestimmungen</a>
                und
                <a routerLink="/terms" queryParamsHandling="preserve">Nutzungsbedingungen</a> zu.
              </p>
            </div>
          } @else {
            <p>
              Die Anzeige der AI-Analysen begründet keine inhaltliche Verantwortlichkeit der
              finanzen.net zero GmbH. Die Verantwortung für die Erstellung und Bereitstellung der
              AI-Analysen liegt ausschließlich bei der finanzen.net GmbH als Datenanbieter.
            </p>
            <div class="disclaimer">
              <p class="terms">
                Mit dem Fortfahren stimmst du den
                <a routerLink="/terms" queryParamsHandling="preserve">Nutzungsbedingungen</a>
                der <strong>finanzen.net GmbH</strong> zu und nimmst deren
                <a routerLink="/privacy" queryParamsHandling="preserve">DSGVO</a> zur Kenntnis.
              </p>
            </div>
          }
        } @else {
          <p [innerHTML]="this.formatText(stepsToShow[step()].subtitle)"></p>
        }

        <div class="buttonContainer">
          <app-button
            (buttonClick)="incrementStep()"
            [text]="step() === 1 ? 'Verstanden und fortfahren' : 'Weiter'"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
}
